import { useQuery } from '@tanstack/react-query';
import { customerApiEndpoints, roleApiEndpoints } from '@/api/endpoints';

export function useUsers() {
  return useQuery({
    querykey: ['user-list'],
    queryFn: async () => {
      const { data } = await customerApiEndpoints.retrieveList();
      return data;
    },
  });
}
